import React from 'react';
import {Path} from "../components/svg/components/path";
import {useThemeColor} from "../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../app/consts/colors";

export const NavigationArrowBack = ({style = { width: 24, height: 24, fill: useThemeColor(COLORS.blackPrimary)}, ...rest}) => {
  return <svg focusable="false"  viewBox={`0 0 24 24`} aria-hidden="true" {...style} {...rest}>
    <Path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
  </svg>
}
